import { I as Icon, _ as __assign } from './loadable.esm-c9931684.js';
import React from 'react';
import 'styled-components';

var InstagramIcon = function (props) { return (React.createElement(Icon, __assign({}, props, { viewBox: "0 0 26 26" }),
    React.createElement("path", { d: "M19.4 7.9c0 .7-.5 1.2-1.2 1.2S17 8.6 17 7.9s.5-1.2 1.2-1.2c.6 0 1.2.5 1.2 1.2zM18 13c0 2.8-2.2 5-5 5s-5-2.2-5-5 2.2-5 5-5 5 2.2 5 5zm-2.5 0c0-1.4-1.1-2.5-2.5-2.5s-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5 2.5-1.1 2.5-2.5zM23 8v10c0 2.6-2.4 5-5 5H8c-2.6 0-5-2.4-5-5V8c0-2.6 2.4-5 5-5h10c2.6 0 5 2.4 5 5zm-2.5 0c0-1.2-1.3-2.5-2.5-2.5H8C6.8 5.5 5.5 6.8 5.5 8v10c0 1.2 1.3 2.5 2.5 2.5h10c1.2 0 2.5-1.3 2.5-2.5V8z" }))); };

export default InstagramIcon;
